import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Breadcrumb, Icon} from 'element-react';

import BreadcrumbNameMap from './routerNameMap';
require ("./index.scss");
var breadcrumbMap= new Array(); 

const Bread = withRouter((props) => {
  //location 为浏览器默认的api
  const { location } = props;
  const breadcrumbNameMap = BreadcrumbNameMap;

  const url = location.pathname
  breadcrumbMap = url.split("/").filter(d=>d)
  // console.log('breadcrumbMap',breadcrumbMap)
  let isIndex = false;
  if ( url === '/entrance/home' || url === '/login' || url === '/register' || url === '/find' || url === '/step' || url === '/reset' || url === '/success' || url == '/preferential/preferential' || url == '/educationTraining/educationTraining') {
    isIndex = true;
  }

  function goBack(url){
    props.history.replace(url)
    window.location.reload()
  }  

  function isDetail(url){
      let detailList = ['InformationDetails','PolicyDetails','soldierDetail','preferentialPolicyDetail','applicationProcess','preferentialProductsDetail','applicationGuide'];
      for(var i=0;i<detailList.length;i++){
        if(url == detailList[i]){
          return true;
        }
      }
  }
  const nameItem = breadcrumbNameMap[url]
  const breadcrumbItems = [ breadcrumbMap.map
    ((_, index) => {
      let url = `/${breadcrumbMap.slice(0, index + 1).join('/')}`;
      if(isDetail(breadcrumbMap[index])){
        return (
          <Breadcrumb.Item key={url}>
               <span onClick={()=>props.history.goBack()}>返回上页</span>
        </Breadcrumb.Item>
          
      );
      }
      // console.log('url',url)
      // console.log('breadcrumbNameMap[url]',breadcrumbNameMap[1])
      return (
        <Breadcrumb.Item key={url}>
            <span onClick={()=>goBack(url)}>
                {breadcrumbNameMap[url]}
            </span>
        </Breadcrumb.Item>
        
    );
   
      
  })
 
]

  return (
        isIndex ? null :

    <div className="crumbs">
        <div className="container">
          <span>当前位置：</span>
          <Breadcrumb>
               {breadcrumbItems}
            </Breadcrumb>
        </div>
      </div>
            
  );
});

export default Bread;